(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dali-pups-guided-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dp-guided-order')) {
    customElements.define('dp-guided-order', class extends HTMLElement {
      connectedCallback() {
        this.panels = [...this.querySelectorAll('[data-dp-panel]')];
        this.progress = this.querySelector('[data-dp-progress]');
        this.progressItems = [...this.querySelectorAll('[data-dp-progress-item]')];
        this.conditionalStep = this.querySelector('[data-dp-conditional-step]');
        this.stepStatus = this.querySelector('[data-dp-step-status]');
        this.productGrid = this.querySelector('[data-dp-product-grid]');
        this.resultCount = this.querySelector('[data-dp-result-count]');
        this.figureNext = this.querySelector('[data-dp-figure-next]');
        this.genderNext = this.querySelector('[data-dp-gender-next]');
        this.productTemplate = this.querySelector('[data-dp-product-template]');
        this.sentinel = this.querySelector('[data-dp-sentinel]');
        this.sources = JSON.parse(this.querySelector('[data-dp-sources]').textContent);
        this.cache = new Map();
        this.products = [];
        this.rendered = 0;
        this.requestId = 0;
        this.count = null;
        this.gender = null;
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.renderNextBatch();
        }, { rootMargin: '500px 0px' });
        this.observer.observe(this.sentinel);
        this.querySelectorAll('[data-dp-count]').forEach((button) => button.addEventListener('click', () => this.selectCount(button)));
        this.querySelectorAll('[data-dp-gender]').forEach((button) => button.addEventListener('click', () => this.selectGender(button)));
        this.figureNext.addEventListener('click', () => this.continueFromCount());
        this.genderNext.addEventListener('click', () => this.continueFromGender());
        this.querySelectorAll('[data-dp-back]').forEach((button) => button.addEventListener('click', () => this.goBack()));
        this.querySelectorAll('[data-dp-restart]').forEach((button) => button.addEventListener('click', () => this.reset()));
        this.updateProgress('figures');
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      selectCount(button) {
        this.count = button.dataset.dpCount;
        this.gender = null;
        this.querySelectorAll('[data-dp-count]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-dp-gender]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        this.setContinueState(this.figureNext, true);
        this.setContinueState(this.genderNext, false);
      }

      continueFromCount() {
        if (!this.count) return;
        if (this.count === '1') {
          this.showPanel('gender');
          this.updateProgress('gender');
        } else {
          this.showProducts(this.count);
        }
      }

      selectGender(button) {
        this.gender = button.dataset.dpGender;
        this.querySelectorAll('[data-dp-gender]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.setContinueState(this.genderNext, true);
      }

      continueFromGender() {
        if (!this.gender) return;
        this.showProducts(this.gender);
      }

      setContinueState(button, enabled) {
        button.disabled = !enabled;
        button.setAttribute('aria-disabled', String(!enabled));
        button.classList.toggle('is-ready', enabled);
      }

      async showProducts(group) {
        this.showPanel('design');
        this.updateProgress('design');
        this.showSkeletons();
        const requestId = ++this.requestId;
        try {
          const products = await this.getProducts(group);
          if (requestId !== this.requestId) return;
          this.products = products;
          this.rendered = 0;
          this.productGrid.replaceChildren();
          this.resultCount.textContent = products.length
            ? this.dataset.foundTemplate.replace('__COUNT__', products.length)
            : this.dataset.emptyLabel;
          this.renderNextBatch();
        } catch (error) {
          if (requestId !== this.requestId) return;
          this.productGrid.replaceChildren();
          this.resultCount.textContent = this.dataset.errorLabel;
        }
      }

      async getProducts(group) {
        if (this.cache.has(group)) return this.cache.get(group);
        const source = this.sources[group];
        if (!source?.url) return [];
        const separator = source.url.includes('?') ? '&' : '?';
        const response = await fetch(`${source.url}/products.json${separator}limit=250`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`Catalog request failed: ${response.status}`);
        const payload = await response.json();
        const products = (payload.products || []).filter((product) => this.matchesFigureCount(product, source.mode));
        this.cache.set(group, products);
        return products;
      }

      matchesFigureCount(product, mode) {
        const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
        const normalized = tags.map((tag) => String(tag).trim().toLocaleLowerCase('tr'));
        const countTags = ['ikili', 'üçlü', 'dörtlü', 'beşli', 'altılı', 'yedili', '7li'];
        if (mode === 'single') return !normalized.some((tag) => countTags.includes(tag));
        const wanted = {
          2: ['ikili'],
          3: ['üçlü'],
          4: ['dörtlü'],
          5: ['beşli'],
          6: ['altılı'],
          7: ['yedili', '7li']
        };
        return (wanted[mode] || []).some((tag) => normalized.includes(tag));
      }

      showSkeletons() {
        this.products = [];
        this.rendered = 0;
        this.resultCount.textContent = this.dataset.loadingLabel;
        const fragment = document.createDocumentFragment();
        for (let index = 0; index < 6; index += 1) {
          const skeleton = document.createElement('span');
          skeleton.className = 'dp-guided-order__product is-skeleton';
          skeleton.setAttribute('aria-hidden', 'true');
          fragment.append(skeleton);
        }
        this.productGrid.replaceChildren(fragment);
      }

      renderNextBatch() {
        if (this.rendered >= this.products.length) return;
        const batchSize = window.matchMedia('(min-width: 990px)').matches ? 16 : 12;
        const next = this.products.slice(this.rendered, this.rendered + batchSize);
        const fragment = document.createDocumentFragment();
        next.forEach((product, index) => {
          const absoluteIndex = this.rendered + index;
          fragment.append(this.createProductCard(product, absoluteIndex === 0, absoluteIndex < 4));
        });
        this.productGrid.append(fragment);
        this.rendered += next.length;
      }

      createProductCard(product, popular, priority) {
        const card = this.productTemplate.content.firstElementChild.cloneNode(true);
        const image = card.querySelector('img');
        const imageSource = product.images?.[0]?.src || product.image?.src;
        card.href = `${window.Shopify?.routes?.root || '/'}products/${product.handle}`;
        card.querySelector('[data-dp-card-title]').textContent = product.title;
        card.querySelector('[data-dp-card-choose]').textContent = this.dataset.chooseLabel;
        card.querySelector('[data-dp-card-price]').textContent = this.formatPrice(product);
        if (imageSource) {
          const imageUrl = new URL(imageSource, window.location.origin);
          imageUrl.searchParams.set('width', '480');
          image.src = imageUrl.toString();
          image.alt = product.images?.[0]?.alt || product.title;
          image.loading = priority ? 'eager' : 'lazy';
          if (priority) image.fetchPriority = 'high';
        } else {
          image.remove();
        }
        if (popular) {
          const badge = card.querySelector('[data-dp-card-popular]');
          badge.textContent = this.dataset.popularLabel;
          badge.hidden = false;
        }
        return card;
      }

      formatPrice(product) {
        const variant = product.variants?.find((item) => item.available) || product.variants?.[0];
        const value = Number(variant?.price || 0);
        return new Intl.NumberFormat(this.dataset.locale, {
          style: 'currency',
          currency: this.dataset.currency,
          maximumFractionDigits: value % 1 === 0 ? 0 : 2
        }).format(value);
      }

      goBack() {
        const current = this.panels.find((panel) => !panel.hidden)?.dataset.dpPanel;
        if (current === 'design' && this.count === '1') {
          this.showPanel('gender');
          this.updateProgress('gender');
          return;
        }
        this.showPanel('figures');
        this.updateProgress('figures');
      }

      reset() {
        this.requestId += 1;
        this.count = null;
        this.gender = null;
        this.querySelectorAll('[aria-pressed]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        this.setContinueState(this.figureNext, false);
        this.setContinueState(this.genderNext, false);
        this.showPanel('figures');
        this.updateProgress('figures');
      }

      showPanel(name) {
        const update = () => {
          this.panels.forEach((panel) => { panel.hidden = panel.dataset.dpPanel !== name; });
        };
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (document.startViewTransition && !reduceMotion) document.startViewTransition(update);
        else update();
        window.setTimeout(() => {
          const heading = this.querySelector(`[data-dp-panel="${name}"] h2`);
          heading?.focus({ preventScroll: true });
          this.querySelector('[data-dp-panel]:not([hidden])')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }, reduceMotion ? 0 : 180);
      }

      updateProgress(current) {
        const hasGender = this.count === '1' || this.count === null;
        this.conditionalStep.hidden = !hasGender;
        const visible = this.progressItems.filter((item) => !item.hidden);
        this.progress.style.setProperty('--dp-visible-steps', visible.length);
        const currentIndex = Math.max(0, visible.findIndex((item) => item.dataset.dpProgressItem === current));
        visible.forEach((item, index) => {
          item.classList.toggle('is-complete', index < currentIndex);
          if (index === currentIndex) item.setAttribute('aria-current', 'step');
          else item.removeAttribute('aria-current');
          item.querySelector(':scope > span').textContent = index + 1;
        });
        this.stepStatus.textContent = `${this.dataset.stepWord} ${currentIndex + 1} / ${visible.length}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
